module.exports = __webpack_public_path__ + "img/1.118b3a53.png";